import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center py-4 px-4 sm:px-6 mt-5 bg-white border-t border-gray-200" }
const _hoisted_2 = { class: "flex sm:flex-1 sm:justify-between sm:items-center" }
const _hoisted_3 = { class: "text-sm text-gray-700" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" results ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_pagination = _resolveComponent("n-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pagerFrom), 1),
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.pagerTo), 1),
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formattedTotal), 1),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_n_pagination, {
          "item-count": _ctx.meta.total,
          "page-size": _ctx.meta.per_page,
          page: _ctx.meta.current_page,
          "onUpdate:page": _ctx.setPage,
          "show-quick-jumper": ""
        }, null, 8, ["item-count", "page-size", "page", "onUpdate:page"])
      ])
    ])
  ]))
}